import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';

const DateRangePicker = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  startLabel,
  endLabel,
  sx = {},
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 w-full">
        {/* Start Date Picker */}
        <div className="flex-1 relative min-w-0">
          <DatePicker
            label={startLabel}
            value={startDate}
            format="DD/MM/YYYY"
            onChange={onStartDateChange}
            sx={{ 
              width: '100%',
              '& .MuiInputBase-root': {
                paddingRight: startDate ? '48px' : '32px', // Dynamic padding based on clear icon presence
              },
              ...sx 
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
              />
            )}
          />
          {startDate && (
            <IconButton
              aria-label="clear start date"
              onClick={() => onStartDateChange(null)}
              size="small"
              sx={{
                position: 'absolute',
                right: { xs: 8, sm: 10 }, // Responsive positioning
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 10,
                backgroundColor: 'transparent',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          )}
        </div>

        {/* End Date Picker */}
        <div className="flex-1 relative min-w-0">
          <DatePicker
            label={endLabel}
            value={endDate}
            onChange={onEndDateChange}
            format="DD/MM/YYYY"
            sx={{ 
              width: '100%',
              '& .MuiInputBase-root': {
                paddingRight: endDate ? '48px' : '32px', // Dynamic padding based on clear icon presence
              },
              ...sx 
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
              />
            )}
          />
          {endDate && (
            <IconButton
              aria-label="clear end date"
              onClick={() => onEndDateChange(null)}
              size="small"
              sx={{
                position: 'absolute',
                right: { xs: 8, sm: 10 }, // Responsive positioning
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 10,
                backgroundColor: 'transparent',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          )}
        </div>
      </div>
    </LocalizationProvider>
  );
};

export default DateRangePicker;